import PropTypes from 'prop-types';
import { Box, Card, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import PopularAdvertisement from '../../layouts/ui-component/cards/card-content/PopularAdvertisement';
import MainCard from '../../layouts/ui-component/cards/MainCard';
import { Button } from '@mui/material';
import { IconArrowRight } from '@tabler/icons';
import Slider from 'react-slick/lib/slider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Color from '../../layouts/Color';

// ===============================|| Advertisement BOX ||=============================== //

const buttonWidth = { maxWidth: '20em' };
const AdvertisementBox1 = ({ bgcolor, dark, matchDownSm }) => (
    <>
        <Card >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 2.5,
                    bgcolor,
                    m: 1,
                    borderRadius: '5px',
                    color: dark ? Color.Main : Color.Button,
                }}
            >
                <Grid container spacing={1} justifyContent="center" alignItems="center" flexDirection="column">
                    <Grid item >
                        <img src={'./assets/images/dashboard/1.png'} alt="Advertisement" style={{ borderRadius: '5px', height: `${matchDownSm ? '150px' : '212px'}` }} />
                    </Grid>
                    <Grid item >
                        <Button endIcon={<IconArrowRight color={Color.Main} />}>
                            <Typography variant="subtitle2"> Register for Apollo - Win gifts from 500,000 VND</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    </>
);

const AdvertisementBox2 = ({ bgcolor, dark, matchDownSm }) => (
    <>
        <Card >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 2.5,
                    bgcolor,
                    m: 1,
                    borderRadius: '5px',

                    color: dark ? Color.Main : Color.Button,
                }}
            >
                <Grid container spacing={1} justifyContent="center" alignItems="center" flexDirection="column">
                    <Grid item >
                        <img src={'./assets/images/dashboard/2.jpg'} alt="Advertisement" style={{ borderRadius: '5px', height: `${matchDownSm ? '150px' : '212px'}` }} />
                    </Grid>
                    <Grid item >
                        <Button endIcon={<IconArrowRight color={Color.Main} />} >
                            <Typography variant="subtitle2"> Offers to transfer money from Vietnam to abroad</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    </>
);

const AdvertisementBox3 = ({ bgcolor, dark, matchDownSm }) => (
    <>
        <Card >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 2.5,
                    bgcolor,
                    m: 1,
                    borderRadius: '5px',
                    color: dark ? Color.Main : Color.Button,
                }}
            >
                <Grid container spacing={1} justifyContent="center" alignItems="center" flexDirection="column">
                    <Grid item >
                        <img src={'./assets/images/dashboard/3.jpg'} alt="Advertisement" style={{ borderRadius: '5px', width: `${matchDownSm ? '' : '379px'}`, height: `${matchDownSm ? '150px' : '212px'}` }} />
                    </Grid>
                    <Grid item >
                        <Button endIcon={<IconArrowRight color={Color.Main} />} >
                            <Typography variant="subtitle2">200,000 billion VND personal loan incentives</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    </>
);

const AdvertisementBox4 = ({ bgcolor, dark, matchDownSm }) => (
    <>
        <Card >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 2.5,
                    m: 1,
                    bgcolor,
                    borderRadius: '5px',
                    color: dark ? Color.Main : Color.Button,
                }}
            >
                <Grid container spacing={1} justifyContent="center" alignItems="center" flexDirection="column">
                    <Grid item >
                        <img src={'./assets/images/dashboard/4.jpg'} alt="Advertisement" style={{ borderRadius: '5px', height: `${matchDownSm ? '150px' : '212px'}` }} />
                    </Grid>
                    <Grid item >
                        <Button endIcon={<IconArrowRight color={Color.Main} />} style={buttonWidth}>
                            <Typography variant="subtitle2">Apollo MetLife Life Offer 3rd 2022</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    </>
);

AdvertisementBox1.propTypes = {
    bgcolor: PropTypes.string,
    title: PropTypes.string,
    data: PropTypes.object.isRequired,
    dark: PropTypes.bool,
    matchDownSm: PropTypes.bool

};

// ==============================|| Advertisement ||============================== //

const Advertisement = ({ isLoading }) => {

    const theme = useTheme();

    const matchDownSm = useMediaQuery(theme.breakpoints.down('sm'))

    var settings = {
        dots: false,
        infinite: true,
        speed: 400,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        autoplay: true,
        pauseOnHover: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    speed: 400,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    pauseOnHover: true,
                    arrows: false
                }
            }
        ]

    };

    return (


        <>
            {isLoading ? (
                <PopularAdvertisement />
            ) : (
                <MainCard>
                    <Slider {...settings} >

                        <div>
                            <AdvertisementBox1 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox1>
                        </div>
                        <div>
                            <AdvertisementBox2 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox2>
                        </div>
                        <div>
                            <AdvertisementBox3 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox3>
                        </div>

                    </Slider>


                    <Slider {...settings}>
                        <div>
                            <AdvertisementBox4 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox4>
                        </div>

                        <div>
                            <AdvertisementBox3 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox3>
                        </div>

                        <div>
                            <AdvertisementBox1 bgcolor={Color.MainBackGround} data={{ label: 'Main-BackGround', color: '#D5E5DA' }} dark matchDownSm={matchDownSm}>
                            </AdvertisementBox1>
                        </div>
                    </Slider>
                </MainCard>
            )}
        </>
    );
};

Advertisement.propTypes = {
    isLoading: PropTypes.bool
};

export default Advertisement;
